<template>
  <v-dialog v-model="dialog" width="500" transition="fab-transition">
    <v-card class="pl-0 pr-0" style="height:100%; width: 100%;">
      <v-card-title style="height:20%">
        <v-icon class="mr-3">fas fa-lock</v-icon>
        <span class="description-selected">
          Descarga de Reactivos
        </span>
      </v-card-title>
      <v-divider></v-divider>

      <v-card-actions>
        <div v-if="form.reactivos.length > 0">
          <div v-for="(item, indice) of form.reactivos" :key="indice">
            <v-checkbox
              v-model="item.select"
              :label="item.product_name"
              :value="item.select"
              style="margin-top:0px!important; padding-top:0px!important"
            ></v-checkbox>
          </div>
        </div>
        <div v-if="form.reactivos.length == 0">
          <label for="">No se registro ningun reactivo</label>
        </div>
      </v-card-actions>

      <v-card-actions>
        <v-container class="pt-0 pb-0" style="height:115px;">
          <v-row style="padding-top:33px;">
            <v-col cols="6">
              <v-btn dark color="red" block @click="handleCancel">
                Cancelar
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                dark
                color="green"
                block
                :disabled="processing"
                @click="handleSaveAddMaterial()"
              >
                Aceptar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>

    <!-- <create-update ></create-update> -->
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";

// import { CreateUpdate } from "./CreateUpdate"

export default {
  name: "AddReactivos",
  props: ["devolverData"],
  components: {
    // CreateUpdate
  },
  data() {
    return {
      dialog: false,
      processing: false,
      form: {
        inventory_id: null,
        cantidad: null,
        reactivos: [],
      },
    };
  },
  computed: {
    ...mapState("material", ["inventories"]),
  },
  methods: {
    ...mapActions("material", ["getMaterialAll"]),
    customText(item) {
      let text = item.description;
      return text;
    },
    showDialog(items) {
      this.form.reactivos = items;
      // console.log("=====>>>>", items);
      this.dialog = true;
      this.clearData();
    },
    clearData() {
      this.clearErrors();
    },
    handleCancel() {
      this.clearData();
      this.dialog = false;
    },
    handleSaveAddMaterial() {
      this.devolverData(this.form.reactivos);
      this.clearData();
      this.dialog = false;
    },
    handleTypeDinamic() {},
    existErrors() {
      let hasErrors = false;

      Object.keys(this.form).forEach((f) => {
        if (this.$refs[f]) {
          if (!this.form[f]) hasErrors = true;
          this.$refs[f].validate(true);
        }
      });

      return hasErrors;
    },
    clearErrors() {
      Object.keys(this.form).forEach((f) => {
        if (this.$refs[f]) this.$refs[f].reset();
      });
    },
  },
};
</script>

<style>
.table-edit {
  height: 90px;
}
</style>
